 <template>
   <div id="landing">
      <div class="header-row">
         <div class="header-grid">
            <div class="header-left">
               <a href="https://www.appriana.com">
                  <div class="logo-pair">
                     <img src="../../assets/appriana-logo-x-small.png" class="appriana-logo-small">
                  </div>
               </a>
            </div>
            <div class="header-center">
               <a href="https://www.appriana.com">
                  <div class="logo-pair">
                     <img src="../../assets/appriana-text-logo.png" class="appriana-text-logo" >
                  </div>
               </a>
            </div>
            <div class="header-right">
               <div class="login-button-small-container">
                  <div class="appriana-apps-nav" @click="navigateToApps()" @mousedown.prevent="preventMouseDown"> 
                  </div>
               </div>
            </div>
         </div>
      </div>
      <div class="content-box">
         <div class="logo-row">
            <img src="../../assets/appriana-logo.png" class="logo-landing" width="196px" height="121px">
            <h1>Enterprise apps made <span class="appriana-focus-maroon">beautiful</span>.</h1>
         </div>
         <schedule-demo></schedule-demo>
         <div class="highlights-row">
            <div id="highlights">
               <div class = "highlight-left">
                  <img src="../../assets/appriana-high-value.png" class="highlight-icon" width="92px" height="92px">
                  <p v-if="selectedPageId === 'pagashi'" class="highlight-brief">
                     Limitless workflows
                  </p>
                  <p v-if="selectedPageId === 'fortress'" class="highlight-brief">
                     <b class="appriana-focus-maroon">Supercharge IT</b> with Fortress's powerful and unified access control engine.
                  </p>
                  <p v-if="selectedPageId === 'spotlight'" class="highlight-brief">
                     Eliminate time wasted on word processors and <b class="appriana-focus-maroon">focus</b> on content.
                  </p>
               </div>
               <div class = "highlight-center">
                  <img src="../../assets/appriana-visibility.png" class="highlight-icon" width="92px" height="92px">
                  <p v-if="selectedPageId === 'pagashi'" class="highlight-brief">
                     Instant visibility
                  </p> 
                  <p v-if="selectedPageId === 'fortress'" class="highlight-brief">
                     Instantly view <b class="appriana-focus-maroon">enterprise-wide</b> insights around operations and access anomalies.
                  </p> 
                  <p v-if="selectedPageId === 'spotlight'" class="highlight-brief">
                     Present your <b class="appriana-focus-maroon">best self</b> and get discovered by hiring managers.
                  </p>
               </div>
               <div class = "highlight-right">
                  <img src="../../assets/appriana-delight.png" class="highlight-icon" width="92px" height="92px">
                  <p v-if="selectedPageId === 'pagashi'" class="highlight-brief">
                    Delighted teams
                  </p>
                  <p v-if="selectedPageId === 'fortress'" class="highlight-brief">
                     <b class="appriana-focus-maroon">Speed up</b> provisioning new services and reduce authorization born delays.
                  </p>
                  <p v-if="selectedPageId === 'spotlight'" class="highlight-brief">
                     Deliver pointed and <b class="appriana-focus-maroon">rich insights</b> around your talents and experience.
                  </p>                              
               </div>
            </div>
            <!--
            <div class="highlight-pages">
               <tab-bar
                  :tabs="highlightPages"
                  :contextPath="'/x/solutions/highlights/' + selectedPageId"
                  :activeItemId="selectedPageId"
                  type="page"
                  @clicked="pageClicked"
               />
            </div>
            -->
         </div>
         <div class="featured-solutions">
            <div class="section-heading"> <h1>Featured <b class="appriana-focus-maroon">solutions</b></h1> </div>
            <div class="featured-entry">
               <div class="solution-icon">
                  <img src="../../assets/appriana_bloom_512px.png" width="160px" height="160px">
               </div>
               <div class="solution-brief">
                  <div class="solution-title">Bloom</div>
                  <br>
                  Transform <b class="spotlight-brand-color">Voice of the Customer to product backlog</b> in minutes. Get precise reports echoing your users' experiences and perceptions. Sidestep costly operations and continuously refine your offerings, unlocking untapped value with each growth iteration.
                  <div class="solution-action">
                     <a tabindex="0" href="https://www.withbloom.ai">Solution</a>
                     ·
                     <a tabindex="0" href="/bloom/waitlist">Waitlist</a>
                  </div>       
               </div>
            </div>
            <div class="featured-entry">
               <div class="solution-icon">
                  <img src="../../assets/appriana_fortress_512px.png" width="144px" height="160px">
               </div>
               <div class="solution-brief">
                  <div class="solution-title">Fortress</div>
                  <br>
                  Defragment your enterprise access controls to speed up IT provisioning.  <b class="fortress-brand-color">Augment operational insights</b> around applications and resources. Set, track and commit field-level permissions, access events and change revisions.
                  <div class="solution-action">
                     Invite Only
                  </div>
               </div>
            </div>
            <div v-if="false" class="featured-entry">
               <div class="solution-icon">            
                  <img src="../../assets/appriana_pagashi_512px.png" width="160px" height="160px">
               </div>
               <div class="solution-brief">
                  <div><b> Pagashi </b></div>
                  <br>
                  Instantly <b class="pagashi-brand-color">boost your PMO</b> and delight all stakeholders. Pagashi employs EVM to support CapEx Budgeting, Planning and Project Controls. Experience the joy of near-realtime visbility and smart tracking of portfolio-wide KPIs.
                  <div class="solution-action">
                     TBA
                  </div>
               </div>
            </div>
            <div v-if="false" class="featured-entry">
               <div class="solution-icon">
                  <img src="../../assets/appriana_spotlight_512px.png" width="154px" height="154px">
               </div>
               <div class="solution-brief">
                  <div><b> Spotlight </b></div>
                  <br>
                  Showcase your skills with embedded insights for recruiters, employers and teams. Employ proven content presentation and <b class="spotlight-brand-color">maximize your return on interaction</b>. Move beyond keywords to effectively communicate your value.
                  <div class="solution-action">
                    TBA
                  </div>
               </div>
            </div>
         </div>
         <div class="integrations-row">
            <div class="section-heading"> <h1>Made for <b class="appriana-focus-maroon">enterprise</b></h1></div>
            <div class="enterprise-integrations">
               <div class="integrations-item">
                  <img src="../../assets/appriana-timeline.png" class="integrations-icon" width="45px" height="45px">
                  <div class="integrations-label">Audit Logs</div>
               </div>
               <div class="integrations-item">
                  <a href="/whitepapers/multi-intelligence-workflows">
                     <img src="../../assets/appriana-miw.png" class="integrations-icon" width="45px" height="45px">
                     <div class="integrations-label">Multi-Intelligence</div>
                  </a>
               </div>
               <div class="integrations-item">
                  <img src="../../assets/appriana-mobile.png" class="integrations-icon" width="45px" height="45px">
                  <div class="integrations-label">Mobile</div>
               </div>
               <div class="integrations-item">
                  <img src="../../assets/appriana-sso.png" class="integrations-icon" width="45px" height="45px">
                  <div class="integrations-label">SSO</div>
               </div>
               <div class="integrations-item">
                  <img src="../../assets/appriana-groups.png" class="integrations-icon" width="45px" height="45px">
                  <div class="integrations-label">IAM Controls</div>
               </div>
               <div class="integrations-item">
                  <img src="../../assets/appriana-apis.png" class="integrations-icon" width="45px" height="45px">
                  <div class="integrations-label">Integration APIs</div>
               </div>
            </div>
         </div>
      </div>
      <site-footer ref="footerElement"></site-footer>
   </div>      
</template>

<script>
export default {
   name: 'Landing',
   data () {
      return {
         selectedPageId: 'pagashi',
         viewportSize: 0
      }
   },
   computed: {
      highlightPages: function() {
         return [
            { id: 'pagashi', label: 'Pagashi' },
            { id: 'fortress', label: 'Fortress' },
            { id: 'spotlight', label: 'Spotlight' }
         ];
      }
   }, 
   mounted() {
      this.updateViewportSize();
      window.addEventListener('resize', this.updateViewportSize);
   },
   created: function() {
      window.addEventListener('resize', this.updateViewportSize);
   },
   destroyed: function() {
      window.removeEventListener('resize', this.updateViewportSize);
   },
   methods: {
      preventMouseDown: (e) => {},
      navigateToApps: function () {
         if (this.$cookie.get('_xorg') === 'dotorg') {
            window.location = 'https://auth.appriana.com' + '/logout';
         } else {
            window.location = 'https://auth.appriana.com' + '/';
         }
      },
      updateViewportSize() {
         this.viewportSize = window.innerWidth;
      },
      pageClicked: function (payload) {
         this.selectedPageId = payload.itemId;
      }      
   }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

/* + General Page Style */
#landing {
   display: grid;
   height: 99vh;
   margin: auto;
}

/* - General Page Style */

/* + Header Row */
.header-row {
   border-bottom: solid 1px #EEEEEE; /* COLOR LIGHT GREY */
   min-height: 60px;

}

.header-grid {
   display: grid;
   grid-template-areas: "left center right";
   grid-template-columns: 20% 60% 20%;
   margin: auto;
   align-items: center;
   justify-content: center;
}

.header-center {
   height: 60px;
   display: flex;
   align-items: center;
   justify-content: center;
}

.header-left {
   display: flex;
   align-items: center;
   padding-left: 1rem;
}

.header-right {
   height: 60px;
   display: flex;
   align-items: center;
   justify-content: flex-end;
   padding-right: 1rem;
}

.logo-pair {
   display: flex;
   align-items: center;
}

.content-box {
   max-width: 64rem;
   margin: auto;
}

.appriana-text-logo {
   width: 102px;
   padding: 4px;
   margin: 4px;
   padding-left: 0px;
   margin-left: 0px;
   margin-top: 0.5em;
}

.appriana-logo-small {
   width: 42px;
   padding: 4px;
   padding-left: 1em;   
   padding-right: 0.5em;
   margin-right: 0px;
}

.appriana-apps-nav {
   background-image: url('../../assets/appriana-apps.svg');
   width: 32px;
   height: 32px;
   cursor: pointer;
}

.appriana-apps-nav:hover {
   background-image: url('../../assets/appriana-apps-active.svg');
}

/* - Header Row */

/* + Logo Row */
.logo-row {
   text-align: center;
   margin: 2em 0rem;
   margin-top: 7em;
}

.logo-landing {
   margin-bottom: 3rem;
}

/* - Logo Row */

/* + Highlights Row */
.section-heading {
   margin: 8rem 0rem 2rem 0rem;
   text-align: center;
}

.highlights-row {
   display: grid;
   grid-template-areas: "hi-items"
                        "hi-tabs";
}

#highlights {
   grid-area: hi-items;
   display: grid;
   grid-template-areas: "hileft hicenter hiright";
   grid-template-columns: 33.3% 33.3% 33.3%;
   margin: auto;
   padding: 1em;
   height: 16rem;
   width: 80%;
   align-items: center;
}


.highlight-left {
   grid-area: hileft;
   text-align: center;
   padding: 1em 0em;
}

.highlight-center {
   grid-area: hicenter;
   text-align: center;
   padding: 1em 0em;
}

.highlight-right {
   grid-area: hiright;
   text-align: center;
   padding: 1em 0em;
}

.highlight-name {
   font-weight: normal;
}

.highlight-icon {
   padding: 5px;
}

.highlight-brief {
   text-align: center;
}

.highlight-pages {
   grid-area: hi-tabs;
   display: flex;
   align-items: center;
   justify-content: center;
}
/* - Highlights Row */

/* + Integrations Row */
.integrations-row {
   text-align: center;
   padding: 0rem 1rem;
}

.enterprise-integrations {
   display: grid;
      grid-template-areas: " integration integration integration "
                           " integration integration integration ";
      grid-template-columns: auto;
   text-align: center;
   margin: auto;
   padding: 1rem 0rem 3rem 0rem;
   place-items: center;
}

.integrations-icon { }

.integrations-label {
   width: 8em;
}

.integrations-item {
   margin-top: 2em;
   margin-bottom: 2em;
}
/* - Integrations Row */

/* + Solutions Row */
.featured-solutions {
   margin: 0rem;
   padding: 0rem;
   margin-top: -4rem;
}

.featured-entry {
   display: grid;
   grid-template-columns: 1fr 3fr;
   padding: 1rem 0rem 0rem 0rem;
}

.solution-title {
   font-size: 1.7rem;
}

.solution-brief {
   padding: 1rem 2rem 1rem 0rem;
}

.solution-icon {
   display: flex;
   align-items: center;
   justify-content: center;
}

.solution-action {
   margin-top: 1rem;
   font-size: 1rem;
   margin-left: 1rem;
   color: #777;
}

.solution-action a {
   color: #777;
}

/* 

.pagashi-brand-color:hover {
   color: #005284; Color Pagashi Blue
}
.fortress-brand-color:hover {
   color: #308f5a; Color Fortress Green
}
.spotlight-brand-color:hover {
   color: #992c23; Color Spotlight Red
}

*/

/* - Solutions Row */

/* + Site Wide Styles */

.appriana-focus-maroon {
   color: #BA0D61;
   font-weight: 500;
}

.login-button-small-container {
   padding: 4px;
   margin: 4px;
   padding-right: 1em;
}

.login-button-small-img {
   width: 32px;
   cursor: pointer;
}


a, u {
  text-decoration: none;
}

a {
  color: black;
}

a:hover {
  color: black;
}

/* - Site Wide Styles */

/* + Specific style overrides */

/* -Specific style overrides */

/* + Responsive UI */
@media screen and (max-width: 760px) {
   #landing { 
      width: auto;
   }

   .logo-row {
      margin-top: 5em;
   }

   .enterprise-integrations {
      width: 100%;
      grid-template-areas: " integration integration integration "
                           " integration integration integration ";
      grid-template-columns: auto;
   }

   .solution-brief {
      padding: 1rem 1rem 1rem 1rem;
   }

   .featured-entry {
      grid-template-columns: 1fr;
      padding: 2rem;
   }   

   .featured-solutions {
      margin-top: 0rem;
   }

}

/* iPhone Screen 375 x 812 */
@media screen and (max-width: 480px) {
   #landing { 
      width: auto;
   }

   h1 {
      font-size: 1.5rem;
   }

   h2 {
      font-size: 1.3rem;
   }

   .solution-title {
      font-size: 1.3rem;
   }

   #highlights {
      width: 92%;
      grid-template-columns: 30% 40% 30%;
      height: 14rem;
   }

   .section-heading {
      margin: 5rem 0rem 2rem 0rem;
      text-align: center;
   }   

   .enterprise-integrations {
      width: 100%;
      grid-template-areas: " integration integration "
                           " integration integration "
                           " integration integration ";
      grid-template-columns: auto;
   }
}
/* - Responsive UI */

</style>



// WEBPACK FOOTER //
// src/components/site/Landing.vue